import { useSignupSelector } from "../hooks";
import { State } from "../state/types";

export const selectCustomer = (state: State) => state.customer;
export const useCustomer = () => useSignupSelector(selectCustomer);
